module.exports = {
    controller: 'searchBoxController',
    templateUrl: 'search/components/large-search-box.html'
};
